import { page, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  // The launch kits (docs/marketing/launch-kit): public, signed in or not, no API.
  public: [
    { path: "streamers", lazy: page(() => import("./StreamerKitPage")) },
    { path: "presse", lazy: page(() => import("./PressKitPage")) },
  ],
};
